import React from 'react';
export function GantryHeaderSection() {
  return <div id="Breton_Gantry" className="bg-[#9B0137] text-white py-6 px-8 rounded-xl mb-12 text-center shadow-md" data-id="element-1339">
      <h2 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-1340">
        High-Speed 5-Axis Gantry Machining Centers
      </h2>
      <div className="flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-8 text-sm font-bold uppercase tracking-wide" data-id="element-1341">
        <a href="uploaded/files/Breton/Breton%20Machine%20Range_EN_11.2022.pdf?direct=1" target="_blank" rel="noopener noreferrer" className="hover:text-orange transition-colors inline-flex items-center" data-id="element-1342">
          <span className="mr-2" data-id="element-1343">+</span> Breton Machine Range Brochure
        </a>
        <a href="https://breton.it/en_na/products/machines-and-lines?filters[businessUnits][]=106287" target="_blank" rel="noopener noreferrer" className="hover:text-orange transition-colors inline-flex items-center" data-id="element-1344">
          <span className="mr-2" data-id="element-1345">+</span> Breton Machine Range
        </a>
      </div>
    </div>;
}